import { base64ToJson } from "../../sg-core/utils/json.helpers";
import { IMap, IMapDTO } from "./Map";

export type TTargetingItem = {
    key: string;
    coordinates: [number, number]
}

export interface ITargetingSchemeDTO {
    id: number;
    nimi: string;
    kartta: IMapDTO["id"];
    base64data: string;
    guid: string;
    viitenimi: string;
};

export interface ITargetingScheme {
    id: number;
    name: string;
    map: IMap["id"];
    targeting: { [key: string]: TTargetingItem };
    guid: string;
    referenceName: string;
};


export const TargetingSchemeMapper = {
    apiToDomain: (api: ITargetingSchemeDTO): ITargetingScheme => {
        const targetingData = api.base64data ? base64ToJson(api.base64data) : {};
        return {
            id: api.id,
            name: api.nimi,
            map: api.kartta,
            targeting: targetingData,
            guid: api.guid,
            referenceName: api.viitenimi,
        }
    }
};
